import {IconPencil} from '@tabler/icons-react';
import {ActionIcon} from 'src/design/atoms/ActionIcon';
import type {ActionIconProps} from 'src/design/atoms/ActionIcon';

/**
 * "Edit" row action icon — thin `ActionIcon` wrapper with a pencil glyph,
 * `color="black"`, `variant="subtle"`.
 * @registry Icon-only "edit" action for table rows/toolbars.
 *
 * Ported from `library-m/components/action-icons/EditActionIcon`. Prop
 * surface kept identical (all `ActionIcon` props pass through). No behavior
 * deviations; `tooltipText` still required by the underlying atom.
 */
export type EditActionIconProps = ActionIconProps;

export const EditActionIcon = ({
  color = 'black',
  variant = 'subtle',
  ...props
}: EditActionIconProps) => (
  <ActionIcon color={color} variant={variant} {...props}>
    <IconPencil />
  </ActionIcon>
);
